export const SLICE_NAME = 'kit';

export const RANDOM_WORDS = `${SLICE_NAME}/RANDOM_WORDS`;
export const CURRENT_WORD = `${SLICE_NAME}/CURRENT_WORD`;
export const CHAR_INCREMENT = `${SLICE_NAME}/CHAR_INCREMENT`;
export const ADD_ANSWER = `${SLICE_NAME}/ADD_ANSWER`;
export const FOCUS_INDEX_INCREMENT = `${SLICE_NAME}/FOCUS_INDEX_INCREMENT`;
export const FOCUS_INDEX_REDUCER = `${SLICE_NAME}/FOCUS_INDEX_REDUCER`;
export const RESET_GAME = `${SLICE_NAME}/RESET_GAME`;
